<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <QuestionBox :title="questionTitle" :desc="questionDesc" :items="questionItem" v-on:selected="selected" :index="questionAnswer" ></QuestionBox>
    <GoNext class="animate-target" v-animate-in href="/section5/5-5" :selected="selectedValue" required="true"></GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt" />
  </div>
</template>

<script>

import SectionTitle from "../../components/SectionTitle";
import QuestionBox from "../../components/QuestionBox";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s5-4",
  components: {SectionTitle, QuestionBox, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return {
      questionTitle: "Question 4",
      questionDesc: "Finerenone may be recommended for patients with T2D and CKD who have:<sup>1</sup>",
      questionItem:[
          "Serum [K+] ≤4.8 mmol/L and eGFR ≥25 mL/min/1.73 m<sup>2</sup>",
          "Serum [K+] >5.0 mmol/L and eGFR <25 mL/min/1.73 m<sup>2</sup>",
          "Serum [K+] >5.0 mmol/L and eGFR ≥25 mL/min/1.73 m<sup>2</sup>",
          "None of the above"
      ],
      selectedValue:'',
      questionAnswer:'0',
      noticeTxt:"CKD, chronic kidney disease; eGFR, estimated glomerular filtration rate; T2D, type 2 diabetes.<br/><div class='brs'></div>"
      +"Reference:<br/><div class='brs'></div>"
      +"1. KERENDIA Product Information.",
      title:"Post-activity quiz"
    };
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section5/s5.css";
</style>
